import React from 'react'
import { EstimatorAvatar } from '@paintscout/ui'
import { useUser } from '@paintscout/ui-business'

interface PainterUserAvatarProps {
  className?: string
  userAvatarUrl?: string
}

export default function PainterUserAvatar({ className, userAvatarUrl }: PainterUserAvatarProps) {
  const { user } = useUser()
  if (userAvatarUrl) {
    return <img src={userAvatarUrl} alt="Profile" className={className} />
  }
  return (
    <EstimatorAvatar
      hideTooltip
      user={{
        id: user.user_id,
        firstName: user.user_metadata?.firstName,
        lastName: user.user_metadata?.lastName
      }}
      className={className}
      borderColor={user.user_metadata?.color}
      userPictures={{}}
    />
  )
}
